import request from '@/utils/request'

export function getAuditPendingCount() {
  return request({
    url: '/biz/giftcard/audit-pending-count',
    method: 'get'
  })
}
